import { useLocation } from "@reach/router";

// A custom hook that builds on useLocation to parse
// the query string for you.
export function useQuery(): URLSearchParams {
  return new URLSearchParams(useLocation().search);
}
